"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Drawer_1 = __importDefault(require("@mui/material/Drawer"));
var sizing_1 = require("./sizing");
/** Represents a Drawer that pops up over the side of the scene */
var Component = function (p) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var drawerWidth = (0, sizing_1.getDrawerWidth)(p.platform, p.portrait);
    return (Preact.h(Drawer_1.default, { anchor: (_a = p.anchor) !== null && _a !== void 0 ? _a : 'right', open: (_b = p.open) !== null && _b !== void 0 ? _b : false, sx: __assign({ width: drawerWidth }, p.sx), SlideProps: {
            mountOnEnter: (_d = (_c = p.mountOptions) === null || _c === void 0 ? void 0 : _c.mountOnEnter) !== null && _d !== void 0 ? _d : false,
            unmountOnExit: (_f = (_e = p.mountOptions) === null || _e === void 0 ? void 0 : _e.unmountOnExit) !== null && _f !== void 0 ? _f : false,
        }, PaperProps: {
            sx: {
                width: drawerWidth,
                paddingTop: (0, sizing_1.toPixels)((_g = p.paddingTop) !== null && _g !== void 0 ? _g : 0),
                height: "calc(100% - ".concat((0, sizing_1.toPixels)((_h = p.paddingTop) !== null && _h !== void 0 ? _h : 0), ")"),
            },
        }, onClose: p.onClose }, (_j = p.children) !== null && _j !== void 0 ? _j : null));
};
exports.Component = Component;
